import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { BACKEND_STATE, EDITOR_VIEW_NAME, PROJECT_COORDINATES } from "../core/constants";
import { translate } from "../core/i18n";
import { store } from "../core/state";
import { getViewData } from "../core/views";
import { backendActive, backendStates, getBackendStatusText } from "../features/backend";

export const getStatusIndicator = (status: string) => {
  switch (status) {
    case backendStates.initializing: 
    case backendStates.connecting: 
    case backendStates.uploading: 
    case backendStates.requesting: 
    case backendStates.executing: return <span className="spinner-border small-status"></span>;
    case backendStates.online: return <FontAwesomeIcon icon="circle" color="green" />;
    case backendStates.connected: return <FontAwesomeIcon icon="circle" color="green" />;
    case backendStates.uploaded: return <FontAwesomeIcon icon="circle" color="blue" />;
    case backendStates.initialized: return <FontAwesomeIcon icon="circle" color="blue" />;
    case backendStates.error: return <FontAwesomeIcon icon="circle" color="red" />;
    case backendStates.offline: return <FontAwesomeIcon icon="circle" color="red" />;
    case backendStates.finished: return <FontAwesomeIcon icon="circle" color="blue" />;    
    default: return <></>;
  }
}    

export const ProjectBackendStatus = () => {
  const [editorState] = store.useState(EDITOR_VIEW_NAME);
  const [backendState] = store.useState(BACKEND_STATE);
  if (backendActive(editorState) === false) return null;
  
  const statusIndicator = getStatusIndicator(backendState.sessionState);
  const text = translate(getBackendStatusText(backendState.sessionState));
  return (
    <div className="coordinates" id="submenu">            
      <span className="input-group-text">{statusIndicator}&nbsp;{text}</span>
    </div>
  );
}
